import Fab from '@material-ui/core/Fab';
import { history } from 'umi';
import AddIcon from '@material-ui/icons/Add';
import { OPT_ADD } from '@/constants';
import DataTableNativeML from '@/components/DataTableNativeML';
import { download } from '@/utils/downloadUtil';
import ResultListStyled from './ResultListStyled';
const ResultList = (props) => {
  const { handlePageChange, pageData, listLoading } = props;
  //列表数据
  const { data, total } = props?.tableData || {};
  const statusData = [
    { value: '0', name: '处理中' },
    { value: '1', name: '已完成' },
    { value: '2', name: '处理失败' },
  ];
  const columns = [
    {
      align: 'center',
      title: '任务名称',
      id: 'taskName',
      key: 'taskName',
      width: 180,
    },
    {
      align: 'center',
      title: '生成数量',
      id: 'issueQuantity',
      key: 'issueQuantity',
      width: 180,
    },
    {
      align: 'center',
      title: '领取数量',
      id: 'receiveQuantity',
      key: 'receiveQuantity',
      width: 220,
    },
    {
      align: 'center',
      title: '创建时间',
      id: 'createDate',
      key: 'createDate',
      width: 170,
    },
    {
      align: 'center',
      title: '状态',
      id: 'generateCodeFlag',
      key: 'generateCodeFlag',
      width: 220,
      render: (item) => {
        return (
          statusData.find(
            (status) => status.value === String(item.generateCodeFlag),
          )?.name || '-'
        );
      },
    },

    {
      title: '操作',
      align: 'center',
      // id: 'mobile',
      // key: 'mobile',
      width: 280,
      render: (item) => {
        if (item.generateCodeFlag) {
          return (
            <div
              align="center"
              className="handle_btn"
              onClick={() => handleDown(item.id)}
            >
              下载
            </div>
          );
        }
        return '-';
      },
    },
  ];

  const handleDown = (id) => {
    download('/coupon/downCouponCodeList', { taskId: id });
  };

  const handleAddIssuance = () => {
    history.push({
      pathname: '/coupon/coupon_issuance/add',
      query: {
        opt: OPT_ADD,
      },
    });
  };

  return (
    <ResultListStyled>
      <div className="export-wrapper">
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleAddIssuance}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建任务
        </Fab>
      </div>
      <DataTableNativeML
        loading={listLoading}
        columns={columns}
        changePage={handlePageChange}
        page={pageData}
        // page={searchParam}
        paging={true}
        data={data}
        total={total}
        columnKey="id"
      ></DataTableNativeML>
    </ResultListStyled>
  );
};
export default ResultList;
